export const portfolio = [
  {
    id: 1,
    title: 'Rénovation Salle de Bain',
    category: 'Plomberie',
    image: 'https://images.unsplash.com/photo-1761353855019-05f2f3ed9c43?q=80&w=1080',
  },
  {
    id: 2,
    title: 'Installation Cuisine Moderne',
    category: 'Menuiserie',
    image: 'https://images.unsplash.com/photo-1686023858213-9653d3248fdc?q=80&w=1080',
  },
  {
    id: 3,
    title: 'Système de Chauffage',
    category: 'Chauffage',
    image: 'https://images.unsplash.com/photo-1761061079418-e7b9fde0707c?q=80&w=1080',
  },
  {
    id: 4,
    title: 'Installation Électrique',
    category: 'Électricité',
    image: 'https://images.unsplash.com/photo-1767514536575-82aaf8b0afc4?q=80&w=1080',
  },
  {
    id: 5,
    title: 'Peinture Intérieure',
    category: 'Décoration',
    image: 'https://images.unsplash.com/photo-1644413132413-a4c2eaa6c00a?q=80&w=1080',
  },
  {
    id: 6,
    title: 'Pose de Parquet',
    category: 'Parquets',
    image: 'https://images.unsplash.com/photo-1548268364-3acee266b695?q=80&w=1080',
  },
];
